import { render, staticRenderFns } from "./EditPackDeals.vue?vue&type=template&id=871c0d84&scoped=true&"
import script from "./EditPackDeals.vue?vue&type=script&lang=js&"
export * from "./EditPackDeals.vue?vue&type=script&lang=js&"
import style0 from "./EditPackDeals.vue?vue&type=style&index=0&id=871c0d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871c0d84",
  null
  
)

export default component.exports